<template>
  <div>
    <div class="box">
      <vue-element-loading :active="isLoading" spinner="spinner" />
      <div class="field has-addons has-text-centered is-vcentered">
        <button
          class="mt-1 button is-rounded is-white is-small"
          @click="getPrev()"
        >
          <i class="fas fa-chevron-left"></i>
        </button>
        <button
          class="mt-1 button is-rounded is-white is-small"
          @click="getNext()"
        >
          <i class="fas fa-chevron-right"></i>
        </button>
        <h5 class="title is-5 ml-3 mt-2">
          {{ year }} {{ $t("reports.year") }}
        </h5>
      </div>

      <BarChart v-bind="barChartProps" />
    </div>
  </div>
</template>
<script>
import imsr from "@/imsr-api";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { ref, computed } from "vue";
import { Chart, registerables } from "chart.js";
import VueElementLoading from "vue-element-loading";
import { BarChart, useBarChart } from "vue-chart-3";
Chart.register(...registerables);

export default {
  components: {
    VueElementLoading,
    BarChart,
  },
  props: {
    tenantId: {
      type: String,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const router = useRoute();
    const { t } = useI18n();
    const isLoading = ref(false);
    const year = ref(null);
    const nextYear = ref();
    const prevYear = ref();
    const data = ref([]);
    const label = ref([]);
    const color = ref(["rgba(54, 162, 235, 0.2)"]);
    const color2 = ref(["rgb(54, 162, 235)"]);

    const chartData = computed(() => ({
      labels: label.value,
      datasets: [
        {
          label: "Count",
          data: data.value,
          borderWidth: 1,
          backgroundColor: color.value,
          borderColor: color2.value,
        },
      ],
      options: {
        responsive: true,
        scales: {
          x: {
            display: true,
          },
        },
      },
    }));

    const options = {
      scales: {
        y: {
          min: 0,
          suggestedMax: 10,
        },
      },
    };

    const { barChartProps, barChartRef } = useBarChart({
      chartData: chartData,
      options,
    });

    const getList = async () => {
      isLoading.value = true;
      try {
        if (year.value == null) {
          let y = new Date();
          year.value = y.getFullYear();
        }
        nextYear.value = year.value + 1;
        prevYear.value = year.value - 1;
        const params = {
          tenantId: props.tenantId,
          projectId: props.projectId,
          startDate: year.value.toString() + "01",
          endDate: year.value.toString() + "12",
        };
        const res = await imsr.imsrGetApi("/events/month", params);
        let buf = [];
        label.value = [];
        res.years[0].months.forEach(function(month) {
          label.value.push(month.month.toString() + t("reports.month"));
          month.devices.forEach(function(device) {
            if (!buf[month.month]) {
              buf[month.month] = 0;
            }
            buf[month.month] += device.count;
          });
        });
        data.value = [];
        color.value = [];
        color2.value = [];
        buf.forEach(function(element) {
          data.value.push(element);
          if (element >= 300) {
            color.value.push("rgba(255, 99, 132, 0.2)");
            color2.value.push("rgba(255,99,132,1)");
          } else {
            color.value.push("rgba(54, 162, 235, 0.2)");
            color2.value.push("rgb(54, 162, 235)");
          }
        });
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
      isLoading.value = false;
    };
    getList();

    const getPrev = () => {
      year.value = prevYear.value;
      getList();
    };

    const getNext = () => {
      year.value = nextYear.value;
      getList();
    };

    return {
      isLoading,
      getPrev,
      getNext,
      chartData,
      year,
      barChartProps,
      barChartRef,
    };
  },
};
</script>
<style>
.has-event {
  padding: 0;
}
</style>
